import { apiMethods } from "../controller/Request";
import { Config } from "../controller/Global";


export const TruckJobGet = (id, params = {}) => {
  const URL = Config['api']['tracks']['truck_job']['get'] + id + '/';
  return apiMethods.get(URL, params, true)
    .then(response => {
      return response
    })

};
export const TruckJobList = (params = {}) => {
  const URL = Config['api']['tracks']['truck_job']['list'];
  return apiMethods.get(URL, params, true)
    .then(response => {
      return response
    })

};
export const TruckJobPost = (params = {}) => {
  const URL = Config['api']['tracks']['truck_job']['post'];
  return apiMethods.post(URL, JSON.stringify(params), true)
    .then(response => {
      return response
    })

};
export const TruckJobUpdate = (id, params = {}) => {
  const URL = Config['api']['tracks']['truck_job']['put'] + id + '/';
  return apiMethods.put(URL, JSON.stringify(params), true)
    .then(response => {
      return response
    })
};

export const TruckJobRemove = (id, params = {}) => {
  const URL = Config['api']['tracks']['truck_job']['delete'] + id + "/";
  return apiMethods.remove(URL, params, true)
    .then(response => {
      return response
    })
};



// WEBPACK FOOTER //
// ./src/models/truckJob.jsx